import React, { useEffect } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { Route, Link, withRouter } from "react-router-dom";
import { GetUserInfo } from "./modules/account";
import Logo from "./images/logo.png";
import LogoGrey from "./images/logo_grey.png";
import Contact from "./container/Contact";
import Main from "./container/Main";
import Download from "./container/Download";
import Membership from "./container/Membership";
import MemberList from "./container/MemberList";
// import PrivacyPoicy from './container/PrivacyPoicy';
import Login from "./container/Login";
import UserInfo from "./container/UserInfo";
import CreateMember from "./container/CreateMember";
import Address from "./container/Address";
import { ToastContainer, cssTransition } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import { confirmAlert } from "react-confirm-alert";
import ConfirmModal from "./common/ConfirmModal";
import "./css/main.css";

const Zoom = cssTransition({
  enter: "zoomIn",
  exit: "zoomOut",
});

const App = ({ location, history }) => {
  const dispatch = useDispatch();
  const { userData } = useSelector(({ account }) => {
    const { userData } = account;
    return {
      userData,
    };
  }, shallowEqual);
  useEffect(() => {
    dispatch(GetUserInfo());
  }, [dispatch]);
  const membershipPopup = (msg) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <ConfirmModal
            title="멤버십"
            content={msg}
            onConfirm={() => {
              onClose();
            }}
          />
        );
      },
    });
  };
  return (
    <div className="container">
      <div className="leftBox">
        <h1 className="logo">
          <img src={Logo} alt="logo" />
        </h1>
        <div className="loginBox">
          {userData ? (
            <UserInfo history={history} userInfo={userData} />
          ) : (
            <Login />
          )}
        </div>
        <div className="menuBox">
          <div className="title">영MAP Mainmenu</div>
          <ul className="menuList">
            <li className={location.pathname === "/" ? "selected" : undefined}>
              <Link to={`/`}>
                <div>Home</div>
              </Link>
            </li>
            <li
              className={
                location.pathname === "/member" ? "selected" : undefined
              }
            >
              {userData && userData.membership_state === "PREMIUM" ? (
                <Link to={`/member`}>
                  <div>My Data</div>
                </Link>
              ) : userData ? (
                <a
                  href={() => false}
                  onClick={() =>
                    membershipPopup(
                      `고객님은 현재 무료 멤버십 이용등급입니다.\n 프리미엄 멤버십을 이용하시면 사용 가능합니다.`
                    )
                  }
                >
                  <div>My Data</div>
                </a>
              ) : (
                <a
                  href={() => false}
                  onClick={() =>
                    membershipPopup(
                      "프리미엄 멤버십에 가입하시면 이용가능합니다.\n먼저 로그인 해주세요."
                    )
                  }
                >
                  <div>My Data</div>
                </a>
              )}
            </li>
            <li
              className={
                location.pathname === "/download" ? "selected" : undefined
              }
            >
              <Link to={`/download`}>
                <div>Download</div>
              </Link>
            </li>
            <li
              className={
                location.pathname === "/membership" ? "selected" : undefined
              }
            >
              <Link to={`/membership`}>
                <div>Membership</div>
              </Link>
            </li>
            <li
              className={
                location.pathname === "/contact" ? "selected" : undefined
              }
            >
              <Link to={`/contact`}>
                <div>Contact</div>
              </Link>
            </li>
          </ul>
        </div>
        <div className="copyright">
          <dl>
            <dt>
              <img src={LogoGrey} alt="logoGrey" />
            </dt>
            <dd>
              <ul>
                <li>사업자: 도미연구소</li>
                <li>대표: 오형석</li>
                <li>사업자번호: 827-06-01560</li>
                {/* <li
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => {
                    history.push("/privacy");
                  }}
                >
                  개인정보처리방침
                </li> */}
              </ul>
            </dd>
          </dl>
          <div></div>
          <div className="copyrightText">
            COPYRIGHTⒸ<b>DomiLabs</b> Inc. All Rights Reserved.
          </div>
        </div>
      </div>
      <div className="contentBox">
        <div className="homeContent">
          <Route exact path="/">
            <Main userData={userData} />
          </Route>
          <Route path="/download" component={Download} />
          <Route path="/membership" component={Membership} />
          <Route path="/contact" component={Contact} />
          {/* <Route path="/privacy" component={PrivacyPoicy}/> */}
          {userData && userData.membership_state === "PREMIUM" && (
            <>
              <Route path="/member" exact={true} component={MemberList} />
              <Route path="/member/create" component={CreateMember} />
            </>
          )}
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={500}
        transition={Zoom}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        closeButton={false}
      />
      <Route path="/address/:query" component={Address} />
    </div>
  );
};

export default withRouter(App);
